import React from 'react'
import './NavBar.css'
import Toggle from './Toggle'
import {Link} from 'react-scroll'
import Portfolio from './Portfolio'
import Experience from './Experience'
function NavBar() {
  return (
    <div className='n-wrapper' id='NavBar'>
        <div className='n-left'>
          <div className='n-name' > Kritik </div>
            <Toggle />
                   
        </div>

        <div className='n-right'>
          <div className='n-list'>
           <ul style={{listStyleType:'none'}}>
            <Link spy={true} to='NavBar' smooth={true} activeClass='activeClass'>
            <li>Home</li>
            </Link>
            
            <Link spy={true} to='Portfolio' smooth={true} activeClass='activeClass'>
            <li>Projects</li>
            </Link>
            <Link spy={true} to='Experience' smooth={true} activeClass='activeClass'>
            <li>Experience</li>
            </Link>
          </ul>
          </div>
          <Link spy={true} to='contact' smooth={true} activeClass='activeClass'>
          <button className='button n-button'> Contact </button>
          </Link>
        </div>
      

    </div>
  )
}

export default NavBar
